import React from 'react'
import { withStyles } from 'material-ui/styles'
import { connect } from 'react-redux'
import * as selectors from 'selectors'
import compose from 'recompose/compose'
import { highlightCurrencies } from 'actions/dashboard'

const HEIGHT = 5
const HEIGHT_BIG = 10
const styles = theme => ({
  root: {
    display: 'flex',
    backgroundColor: theme.palette.background.contentFrame,
  },
  segment: {
    transition: theme.transitions.create(['all'], {
      duration: theme.transitions.duration.standard,
    }),
    minWidth: 1,
  },
})

class Bar extends React.Component {
  render() {
    const {
      classes,
      fund,
      totalbalance,
      colour,
      total,
      big,
      funds,
      highlightCurrencies,
    } = this.props
    let segments = []
    if (total) {
      segments = funds.map(d => ({
        currency: d.currency,
        value: d.value,
        width: d.value / totalbalance * 100,
      }))
    } else {
      segments = [
        {
          currency: fund.currency,
          value: fund.value,
          width: fund.value / totalbalance * 100,
        },
      ]
    }
    return (
      <div
        className={classes.root}
        style={{
          width: `100%`,
          height: big ? HEIGHT_BIG : HEIGHT,
        }}
      >
        {segments.map((seg, i) => (
          <div
            onMouseEnter={() => total && highlightCurrencies([seg.currency])}
            onMouseLeave={() => total && highlightCurrencies([])}
            key={i}
            className={classes.segment}
            style={{
              width: `${seg.width}%`,
              backgroundColor: colour(seg.currency),
            }}
          />
        ))}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  funds: selectors.fundsWithValueMergedByCrypto(state),
  totalbalance: selectors.totalbalance(state),
})
const mapDispatchToProps = dispatch => ({
  highlightCurrencies: f => dispatch(highlightCurrencies(f)),
})

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(Bar)



// WEBPACK FOOTER //
// ./src/components/Bar.js